export default __webpack_public_path__ + "static/patient-engagement-software-development-company-peerbits-df048278ecf7a97699fbd1a0a3519410.png";